import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this._dirty = false

    this._onFormChange = (ev) => { if (ev.isTrusted) this._dirty = true }
    document.addEventListener('change', this._onFormChange, true)
    document.addEventListener('input',  this._onFormChange, true)

    this._onSubmit = () => { this._dirty = false }
    document.addEventListener('submit', this._onSubmit, true)

    this._onBeforeVisit = (ev) => this._handleBeforeVisit(ev)
    document.addEventListener('turbo:before-visit', this._onBeforeVisit)

    this._onBeforeUnload = (ev) => {
      if (!this._dirty) return
      ev.preventDefault()
      ev.returnValue = ''
    }
    window.addEventListener('beforeunload', this._onBeforeUnload)
  }

  clearDirty() {
    this._dirty = false
  }

  disconnect() {
    document.removeEventListener('change', this._onFormChange, true)
    document.removeEventListener('input',  this._onFormChange, true)
    document.removeEventListener('submit', this._onSubmit, true)
    document.removeEventListener('turbo:before-visit', this._onBeforeVisit)
    window.removeEventListener('beforeunload', this._onBeforeUnload)
  }

  async _handleBeforeVisit(event) {
    if (!this._dirty) return

    event.preventDefault()
    const url = event.detail.url

    const result = await Swal.fire({
      title: 'Informações não salvas',
      html: `
        <p class="text-sm text-gray-600 text-center">
          As informações preenchidas serão <strong>perdidas</strong>.<br>
          Salve o rascunho antes de sair.
        </p>`,
      icon: 'warning',
      confirmButtonText: 'Voltar e salvar',
      confirmButtonColor: '#3b82f6',
      showCancelButton: true,
      cancelButtonText: 'Sair sem salvar',
      cancelButtonColor: '#6b7280',
      showCloseButton: true,
      reverseButtons: true,
    })

    if (result.isConfirmed) {
      const btn = document.getElementById('btn-salvar-rascunho')
      if (btn) btn.scrollIntoView({ behavior: 'smooth', block: 'center' })
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      this._dirty = false
      window.location.href = url
    }
  }
}
